import { useCallback, useState, useEffect } from 'react';

// Función para obtener el token de Auth0 desde el almacenamiento
export const useAuth0Token = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const getAuth0Token = useCallback(() => {
    // Buscar el token en localStorage
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      return accessToken;
    }

    // Buscar el token en sessionStorage
    const sessionToken = sessionStorage.getItem('access_token');
    if (sessionToken) {
      return sessionToken;
    }

    // Buscar en otros lugares comunes donde Auth0 puede almacenar el token
    const auth0Token = localStorage.getItem('auth0.access_token');
    if (auth0Token) {
      return auth0Token;
    }

    return null;
  }, []);

  // Verificar el estado de autenticación cuando cambie el token
  useEffect(() => {
    const token = getAuth0Token();
    setIsAuthenticated(!!token);
  }, [getAuth0Token]);

  const clearAuth0Token = useCallback(() => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('auth0.access_token');
    sessionStorage.removeItem('access_token');
    setIsAuthenticated(false);
    console.log('Auth0 tokens cleared');
  }, []);

  return { 
    getAuth0Token, 
    isAuthenticated, 
    clearAuth0Token 
  };
};

export default useAuth0Token;